import DTO from './DTO';

class SubscriptionPresetDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'subs.id',
      },
      {
        name: 'name',
        type: String,
        validators: [],
        labelKey: 'subs.preset.name',
      },
      {
        name: 'duration',
        type: String,
        validators: [],
        labelKey: 'subs.preset.duration',
      },
      {
        name: 'price',
        type: String,
        validators: [],
        labelKey: 'subs.preset.price',
      },
      {
        name: 'priority',
        type: String,
        validators: [],
        labelKey: 'subs.preset.priority',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default SubscriptionPresetDTO;
